export const GET_DELIVERY_USERS = 'get_delivery_users';
export const GET_MMTCS = 'get_dispensers';
export const RESET_MMTCS = 'reset_dispensers';
export const GET_MMTC_PROFILE = 'get_mmtc_profile';
export const RESET_MMTC_PROFILE = 'reset_mmtc_profile';
export const DELETE_MMTC_PROFILE = 'delete_mmtc_profile';
export const EDIT_MMTC_PROFILE = 'edit_mmtc_profile';
export const ADD_MMTC = 'add_mmtc';
